import {
    convertMapToList,
    DEFAULT_STATUS_KEY,
    EntityStatusInfo,
    StatusInfo,
} from 'src/components/EntityStatusInfo/EntityStatusInfo';
import { LegalEntityDto } from 'src/generated-api-client';
import { CssColors } from 'src/styles/CssVariables';

type BorrowerStatusProps = {
    borrower: LegalEntityDto;
};

export const BorrowerStatus = ({ borrower }: BorrowerStatusProps) => {
    if (!borrower.blacklisted) {
        return null;
    }

    return (
        <EntityStatusInfo
            statusInfoMap={borrowerStatusInfoMap}
            status={getBorrowerStatus(borrower)}
            entityName="borrower"
        />
    );
};

const getBorrowerStatus = (item: LegalEntityDto) => {
    if (item.blacklisted) {
        return 'BLACKLISTED';
    }

    return DEFAULT_STATUS_KEY;
};

const borrowerStatusInfoMap: Record<string, StatusInfo> = {
    BLACKLISTED: {
        color: CssColors.mainRed,
        borderColor: CssColors.mainRed,
        title: 'Blacklisted',
        backgroundColor: CssColors.mainRed,
    },
    [DEFAULT_STATUS_KEY]: {
        color: CssColors.mainGray,
        borderColor: CssColors.mainGray,
        title: '',
        backgroundColor: CssColors.mainGray,
    },
};

export const getBorrowerStatuses = () => {
    return convertMapToList(borrowerStatusInfoMap);
};
